import React from "react";

function MyAccounts() {
  return (
    <>Contas</>
  );
}

export default MyAccounts;